import PropTypes from 'prop-types';
import React from 'react';


export default function ImageFallbackServer({ alt, className, divClassName, estabFallbackImages, getFallbackSrc,
  id, index, src }) {
  const fallbackImage = getFallbackSrc(id, estabFallbackImages, index);
  const source = src ? src.replace('res.cloudinary.com/hundredrooms', 'godinary.pimpam.io') : fallbackImage;
  const altAttribute = alt ? `alt="${alt.split('\n').join('').split('\t').join('')}"` : '';
  const node = `
    <img class="${className}" src="${source}" onerror="this.error=null;this.src='${fallbackImage}';" ${altAttribute} />
  `;
  return (<div className={ divClassName } dangerouslySetInnerHTML={ { __html: node } } />);
}

ImageFallbackServer.defaultProps = {
  alt: '',
  className: '',
  divClassName: '',
  id: 0,
  index: 0,
  src: '',
};

ImageFallbackServer.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  divClassName: PropTypes.string,
  estabFallbackImages: PropTypes.arrayOf(PropTypes.string).isRequired,
  getFallbackSrc: PropTypes.func.isRequired,
  id: PropTypes.number,
  index: PropTypes.number,
  src: PropTypes.string,
};
